import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const HideOnScroll = () => {
  const [trigger, setTrigger] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const threshold = 50;
      setTrigger(window.scrollY > threshold);
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Link to="/">
      <div className="flex items-center gap-2">
        <img
          src="/maria/logongang.png"
          alt="Desktop Logo"
          className="hidden md:block h-12" // md: display desktop logo, hidden on mobile
        />

        <img
          src="/maria/logongang.png"
          alt="Mobile Logo"
          className="block md:hidden h-12" // mobile only
        />
      </div>
    </Link>
  );
};

const LogoSignIn = () => {
  return <HideOnScroll />;
};

export default LogoSignIn;
